import { Dropdown, Hamburger, TopBar as TopBarComponent } from "@egovernments/digit-ui-react-components";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
/*
import ChangeCity from "../ChangeCity";
import ChangeLanguage from "../ChangeLanguage";
*/
import MenuPopupState from "@egovernments/digit-ui-module-obps/src/pages/employee/BPAForm11Details/Menu";
import MenuPopupNotification from "@egovernments/digit-ui-module-obps/src/pages/employee/BPAForm11Details/AlertNotification";
import MenuPopupCalender from "@egovernments/digit-ui-module-obps/src/pages/employee/BPAForm11Details/JECalendarMonth";
import UserManualPopup from "../../pages/citizen/Home/AwasBandhu/ManualShow";
import { includes } from "lodash";
import EmpMenu from "@egovernments/digit-ui-module-obps/src/pages/employee/Menu/EmpMenu";
import { AiFillFileExcel } from "react-icons/ai";
const TextToImg = (props) => (
  <span className="user-img-txt" onClick={props.toggleMenu} title={props.name}>
    {props.name[0].toUpperCase()}
  </span>
);
const TopBar = ({
  t,
  stateInfo,
  toggleSidebar,
  isSidebarOpen,
  handleLogout,
  userDetails,
  CITIZEN,
  cityDetails,
  mobileView,
  userOptions,
  handleUserDropdownSelection,
  logoUrl,
  showLanguageChange = true,
  sidebarOpen,
  sidebarToggle,
}) => {
  const [profilePic, setProfilePic] = React.useState(null);
  const [userBusinessServices, setUserBusinessServices] = React.useState(null);
  const [manualOpen, setManualOpen] = React.useState(false);

  const user = Digit.SessionStorage.get("USER_DETAIL") || {};
  const userInfo = Digit.UserService.getUser()?.info || {};
  const officerRole = userInfo?.roles?.filter((item) => item.code !== "EMPLOYEE");

  const designationName = userInfo?.roles?.find((ele) => ele?.code !== "EMPLOYEE")?.name;
  const authority = user?.location1;
  console.log("logforauthority", authority, designationName, user);

  React.useEffect(async () => {
    const tenant = Digit.ULBService.getCurrentTenantId();
    const uuid = userDetails?.info?.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, { uuid: [uuid] }, {});
      if (usersResponse && usersResponse.user && usersResponse.user.length) {
        const userDetails = usersResponse.user[0];
        Digit.SessionStorage.set("USER_DETAIL", userDetails);
        const businessService = userDetails?.organisationName === "noc-services" ? userDetails?.organisationCode : userDetails?.businessService;
        setUserBusinessServices(businessService);
        console.log("userInfoAyush", usersResponse);
        const thumbs = userDetails?.photo?.split(",");
        setProfilePic(thumbs?.at(0));
      }
    }
  }, [profilePic !== null, userDetails?.info?.uuid]);

  const CitizenHomePageTenantId = Digit.ULBService.getCitizenCurrentTenant(true);
  const tenant = Digit.ULBService.getStateId();

  let history = useHistory();
  const { pathname } = useLocation();

  const conditionsToDisableNotificationCountTrigger = () => {
    if (Digit.UserService?.getUser()?.info?.type === "EMPLOYEE") return false;
    if (Digit.UserService?.getUser()?.info?.type === "CITIZEN") {
      if (!CitizenHomePageTenantId) return false;
      else return true;
    }
    return false;
  };

  const { data: { unreadCount: unreadNotificationCount } = {}, isSuccess: notificationCountLoaded } = Digit.Hooks.useNotificationCount({
    tenantId: tenant,
    config: {
      enabled: conditionsToDisableNotificationCountTrigger(),
    },
  });

  const updateSidebar = () => {
    if (!Digit.clikOusideFired) {
      toggleSidebar(true);
    } else {
      Digit.clikOusideFired = false;
    }
  };

  function onNotificationIconClick() {
    history.push("/digit-ui/citizen/engagement/notifications");
  }

  const urlsToDisableNotificationIcon = (pathname) =>
    !!Digit.UserService?.getUser()?.access_token
      ? false
      : ["/digit-ui/citizen/select-language", "/digit-ui/citizen/select-location"].includes(pathname);

  if (CITIZEN) {
    return (
      <TopBarComponent
        img={stateInfo?.logoUrlWhite}
        isMobile={true}
        toggleSidebar={updateSidebar}
        logoUrl={logoUrl || stateInfo?.logoUrlWhite}
        onLogout={handleLogout}
        userDetails={userDetails}
        notificationCount={unreadNotificationCount < 99 ? unreadNotificationCount : 99}
        notificationCountLoaded={notificationCountLoaded}
        cityOfCitizenShownBesideLogo={t(CitizenHomePageTenantId)}
        onNotificationIconClick={onNotificationIconClick}
        hideNotificationIconOnSomeUrlsWhenNotLoggedIn={urlsToDisableNotificationIcon(pathname)}
        sidebarOpen={sidebarOpen}
        sidebarToggle={sidebarToggle}
      />
    );
  }
  const loggedin = userDetails?.access_token ? true : false;
  const nameAuthority = `${designationName}${authority ? ` - ${authority}` : ``}`;
  return (
    <div className="topbar">
      {mobileView ? <Hamburger handleClick={toggleSidebar} color="#9E9E9E" /> : null}
      {/* <img className="city" src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" /> */}
      <span style={{ display: "flex", alignItems: "center", justifyContent: "end", width: "100%" }}>
        {loggedin &&
          (cityDetails?.city?.ulbGrade ? (
            <p className="ulb" style={mobileView ? { fontSize: "14px", display: "inline-block" } : {}}>
              {t(cityDetails?.i18nKey).toUpperCase()}{" "}
              {t(`ULBGRADE_${cityDetails?.city?.ulbGrade.toUpperCase().replace(" ", "_").replace(".", "_")}`).toUpperCase()}
            </p>
          ) : (
            ""
            // <img className="state" src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" />
          ))}
        {!loggedin && (
          <p className="ulb" style={mobileView ? { fontSize: "14px", display: "inline-block" } : {}}>
            {t(`MYCITY_${stateInfo?.code?.toUpperCase()}_LABEL`)} {t(`MYCITY_STATECODE_LABEL`)}
          </p>
        )}
        {!mobileView && (
          <div className={mobileView ? "right" : "flex-right right w-80 column-gap-15"} style={!loggedin ? { width: "80%" } : {}}>
            {/* <div className="left">
              {!window.location.href.includes("employee/user/login") && !window.location.href.includes("employee/user/language-selection") && (
                <ChangeCity dropdown={true} t={t} />
              )}
            </div> */}
            {designationName === "JE" && (
              <div>
                <MenuPopupCalender />
              </div>
            )}

            {/* <div>
              <MenuPopupNotification />
            </div> */}

            <div>
              <button className="btn-header-menu" onClick={() => setManualOpen(true)}>
                {"Help"}
              </button>
              <UserManualPopup open={manualOpen} onClose={() => setManualOpen(false)} />
            </div>

            <div>
              {/* <MenuPopupState
                // parentRoute={path}
                businessService={["BPA_FORM11"]}
                filterComponent="TL_INBOX_FILTER"
                initialStates={{}}
                isInbox={true}
              /> */}
              {/* Below component is implemented to reduce the number of api calls and promote code reusability. */}
              <EmpMenu userBusinessServices={userBusinessServices} tenantId={tenant} officerRole={officerRole} />
            </div>

            {/* <div className="left">{showLanguageChange && <ChangeLanguage dropdown={true} />}</div> */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              <b style={{ fontSize: 18, textAlign: "center", color: "#fff" }}>{userDetails?.info?.name}</b>
              <p style={{ fontSize: 13, color: "#fff" }}>({nameAuthority})</p>
            </div>

            {userDetails?.access_token && (
              <div className="left">
                <Dropdown
                  option={userOptions}
                  optionKey={"name"}
                  select={handleUserDropdownSelection}
                  showArrow={true}
                  freeze={true}
                  style={mobileView ? { right: 0 } : {}}
                  optionCardStyles={{ overflow: "revert", right: 0 }}
                  customSelector={
                    profilePic == null ? (
                      <TextToImg name={userDetails?.info?.name || userDetails?.info?.userInfo?.name || "Employee"} />
                    ) : (
                      <img src={`${profilePic}`} style={{ height: "48px", width: "48px", borderRadius: "50%" }} />
                    )
                  }
                />
              </div>
            )}
            {/* <img className="state" src="https://in-egov-assets.s3.ap-south-1.amazonaws.com/images/Upyog-logo.png" /> */}
          </div>
        )}
      </span>
    </div>
  );
};

export default TopBar;
